import React, { useState } from 'react';
import {
  Flex, Container, VStack, Heading, Text, FormControl, FormLabel,
  Input, Button, Card, CardBody, HStack, Icon
} from '@chakra-ui/react';
import { EmailIcon, ArrowBackIcon } from '@chakra-ui/icons';
import toastService from '../../utils/toastService';
import API_URL from '../../config';

const ForgotPassword = ({ onRouteChange }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async () => {
    if (!email.trim()) {
      toastService.error('Email Required', 'Please enter your email address.');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/forgot_password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (data.success) {
        setSubmitted(true);
        toastService.success('Email Sent', data.message);
      } else {
        toastService.error('Error', data.message);
      }
    } catch (error) {
      toastService.networkError('Request Failed', 'Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <Flex minH="100vh" bg="gray.50">
        <Container maxW="md" py={12}>
          <VStack spacing={8}>
            <VStack spacing={4} textAlign="center">
              <Heading fontSize="3xl" fontWeight="800" bgGradient="linear(to-r, brand.600, purple.600)" bgClip="text">
                Check Your Email
              </Heading>
              <Text fontSize="lg" color="gray.600">
                We've sent a password reset link to {email}
              </Text>
            </VStack>
            <Card shadow="xl" border="1px" borderColor="gray.200" w="full">
              <CardBody p={8}>
                <VStack spacing={4}>
                  <Text color="gray.600">
                    The link will expire in 1 hour. If you don't see the email, check your spam folder.
                  </Text>
                  <Button
                    w="full"
                    variant="outline"
                    onClick={() => onRouteChange('login')}
                    leftIcon={<ArrowBackIcon />}
                  >
                    Back to Login
                  </Button>
                </VStack>
              </CardBody>
            </Card>
          </VStack>
        </Container>
      </Flex>
    );
  }

  return (
    <Flex minH="100vh" bg="gray.50">
      <Container maxW="md" py={12}>
        <VStack spacing={8}>
          <VStack spacing={4} textAlign="center">
            <Heading fontSize="3xl" fontWeight="800" bgGradient="linear(to-r, brand.600, purple.600)" bgClip="text">
              Reset Password
            </Heading>
            <Text fontSize="lg" color="gray.600">
              Enter your email to receive a reset link
            </Text>
          </VStack>
          <Card shadow="xl" border="1px" borderColor="gray.200" w="full">
            <CardBody p={8}>
              <VStack spacing={6}>
                <FormControl>
                  <FormLabel>Email Address</FormLabel>
                  <HStack>
                    <Icon as={EmailIcon} color="gray.400" boxSize={5} />
                    <Input
                      type="email"
                      placeholder="your@email.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      size="lg"
                    />
                  </HStack>
                </FormControl>
                <Button
                  w="full"
                  size="lg"
                  colorScheme="brand"
                  onClick={handleSubmit}
                  isLoading={loading}
                >
                  Send Reset Link
                </Button>
                <Button
                  w="full"
                  variant="ghost"
                  onClick={() => onRouteChange('login')}
                  leftIcon={<ArrowBackIcon />}
                >
                  Back to Login
                </Button>
              </VStack>
            </CardBody>
          </Card>
        </VStack>
      </Container>
    </Flex>
  );
};

export default ForgotPassword;
